"use strict";
(function (global) {

 /**
 * Применяет права доступа на EDMS-объекты.
 *
 * @function WebAccess.services.access.applyEdmsRights
 * @param {WA.Link[]} objectLinks Список ссылок на EDMS-объекты
 * @param {AccessRightsEntryModel[]} rightsEntries Список записей применяемых прав
 * @return {Deferred} Deferred-объект, который содержит список результатов применения прав.
 * @since 5.8.2.4000
 */
  global.access.applyEdmsRights = function (objectLinks, rightsEntries) {
    return global.call('/api/AccessControl.asmx/ApplyEdmsRights',
      {
        edmsObjectLinks: objectLinks,
        accessRightsEntries: rightsEntries,
      });
  };

})(window.WebAccess.services);
